import React from 'react'
import PropTypes from 'prop-types'

import Recipe from '../containers/Recipe'
import Rating from '../../rating/containers/Rating'
//import MiniBrowse from '../../browse/containers/MiniBrowse'

const RecipeView = ({ match }) => (
  <div className="container">
    <div className="row">
      <div className="col-md-10 col-md-offset-1">
        <Recipe match={ match } />
        <Rating match={ match } />
      </div>
    </div>
  </div>
);

RecipeView.PropTypes = {
  match: PropTypes.object.isRequired
};

export default RecipeView;



// WEBPACK FOOTER //
// ./modules/recipe/components/RecipeView.js